// API returns only the tariff name, the limit is enforced upstream
export const EXTENSIONS_LIMIT = {
    trial: 1,
    unlimited: Infinity,
}

export default function useExtensionsLimit() {
    // limit: number, Infinity for unlimited, null for an unknown tariff
    const getExtensionsInfo = (item) => {
        const count = item?.extensions_count ?? 0
        const limit = EXTENSIONS_LIMIT[item?.tariff] ?? null

        return {count, limit}
    }

    const isUnlimited = (item) => getExtensionsInfo(item).limit === Infinity

    return {getExtensionsInfo, isUnlimited}
}